import { render, staticRenderFns } from "./ICategorySelect.vue?vue&type=template&id=0973c90a&scoped=true&"
import script from "./ICategorySelect.vue?vue&type=script&lang=js&"
export * from "./ICategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./ICategorySelect.vue?vue&type=style&index=0&id=0973c90a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0973c90a",
  null
  
)

export default component.exports